<app-header></app-header>
<a id="leftnav" class="vcal-btn"><span>Menu</span></a>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="cp-main-sec">
  <div class="cp-herobanner">
    <img src="assets/images/cpbanner.png" alt="" />
  </div>

  <div class="right-sec gm-right-sec right-slide">
    <div class="gm-right-sec-bg">
      <div class="gm-sec-heading">
        <h2>{{ mapDetails?.map_info?.map_name || 'MAP NAME' }}</h2>
        <div class="gm-btn-sec">
          <button class="btn btn-dark" (click)="goBack()">Back</button>
        </div>
      </div>
      <div class="game-detail-sec">
        <div class="gd-box">
          <ul>
            <li><span>Creator:</span> {{ mapDetails?.creator?.first_name }} {{ mapDetails?.creator?.last_name }}</li>
            <li><span>Active Games:</span> {{ mapDetails?.statistics?.games_created || 0 }}</li>
            <li><span>Linked Establishments:</span> {{ mapDetails?.statistics?.linked_establishments || 0 }}</li>
            <li><span>Linked Adventures:</span> {{ mapDetails?.statistics?.adventures_count || 0 }}</li>
            <li class="downloads-label mt-4"><span>Downloads:</span></li>
        </ul>
      </div>
      <div class="gh-box">
        <ul>
          <li><span>Created:</span> {{ mapDetails?.map_info?.created_at | date:'MM/dd/yyyy' }}</li>
          <li><span>All Characters:</span> {{ mapDetails?.statistics?.active_characters || 0 }}</li>
        </ul>
      </div>

      <div class="map-admin-actions">
        <div class="action-buttons">
          <button class="btn btn-green" (click)="playMap(mapDetails.map_info.map_id)">Play</button>
          <button class="btn btn-green" [disabled]="isGameCreateDisabled()" (click)="newGame(mapDetails)">New game</button>
          <button class="btn btn-dark" (click)="viewWiki(mapDetails)">Wiki</button>
          <button class="btn btn-dark" (click)="downloadGmGuide(mapDetails.map_info.map_id)">GM Guide</button>
          <button class="btn btn-dark" (click)="downloadPlayerGuide(mapDetails.map_info.map_id)">Player guide</button>
        </div>
      </div>
    </div>

    <div class="map-administration-sec">
      <h3>Map Administration:</h3>
      <div class="admin-row">
        <div class="admin-details">
          <ul>
            <li><span>MAP Owner:</span> {{ mapDetails?.map_administration?.owner?.first_name }} {{ mapDetails?.map_administration?.owner?.last_name }}</li>
            @for (user of mapDetails?.map_administration?.invited_users; track user) {
              <li>
                <span>User:</span> {{ user.invited_user__first_name }} {{ user.invited_user__last_name }} ({{ user.status }})
              </li>
            }
          </ul>
        </div>
        <div class="admin-invite">
          @if (user_id == mapDetails?.creator.user_id) {
            <button class="btn btn-dark" (click)="invite(mapDetails.map_info.map_id)">Map invite</button>
          }
        </div>
      </div>
    </div>


    <div class="game-detail-sec map-resources-sec justify-content-between">
      <div class="gd-box">
        <h3>Map Resources</h3>
        <ul>
          <li><span>Farmed:</span> {{ mapDetails?.resources?.farmed || 0 }}</li>
          <li><span>Basic:</span> {{ mapDetails?.resources?.basic || 0 }}</li>
          <li><span>Bonus:</span> {{ mapDetails?.resources?.bonus || 0 }}</li>
          <li><span>Mineral:</span> {{ mapDetails?.resources?.mineral || 0 }}</li>
          <li><span>Special:</span> {{ mapDetails?.resources?.special || 0 }}</li>
        </ul>
      </div>
      <div class="gh-box">
        <h5 class="resource-note">Map Resource Level chosen at Map Upload: (Cannot be changed)</h5>
      </div>
    </div>
    <div class="map-look-sec">
      <h3>Map Look</h3>
      @switch (terrain?.status) {
        @case ('ready') {
          <p class="map-look-note">
            How the land is drawn for everyone on this map.
            @if (!isMapOwner()) { Only the map owner can change it. }
          </p>
          <div class="map-look-options">
            @for (skin of terrain?.skins || []; track skin) {
              <button type="button" class="map-look-option" [class.is-current]="terrain?.skin === skin"
                [disabled]="!isMapOwner() || savingSkin" (click)="chooseSkin(skin)"
                [attr.aria-pressed]="terrain?.skin === skin">
                <span class="map-look-preview">
                  @for (src of skinPreview(skin); track src) {
                    <img [src]="src" alt="" loading="lazy" />
                  }
                </span>
                <span class="map-look-name">{{ skinLabels[skin]?.name || skin }}
                  @if (terrain?.skin === skin) { <span class="map-look-current">Current</span> }
                </span>
                <span class="map-look-blurb">{{ skinLabels[skin]?.blurb }}</span>
              </button>
            }
          </div>
        }
        @case ('baking') {
          <p class="map-look-note">Painting this map's terrain. This takes a few minutes; until then the map uses the classic look.</p>
        }
        @case ('failed') {
          <p class="map-look-note">The painted terrain could not be made for this map, so it uses the classic look.</p>
        }
        @default {
          <p class="map-look-note">This map uses the classic look. Painted terrain is made for maps uploaded with their full Azgaar export.</p>
        }
      }
    </div>

    <!-- future work -->

  <div class="map-image-section">
    <div class="sec-heading">
      <h2>MAP IMAGE</h2>
      @if (user_id == mapDetails?.creator.user_id) {
        <a class="btn btn-dark" (click)="updateMapImage(mapDetails)">Update</a>
      }
    </div>
    <div class="map-preview">
      @if (mapDetails?.map_info?.thumbnail) {
<img [src]="imageUrl + mapDetails?.map_info?.thumbnail + '?t=' + todayDate" alt="{{ mapDetails?.map_info?.map_name }}" class="map-thumbnail" />
}
            @if (!mapDetails?.map_info?.thumbnail && !loading) {
<div class="no-thumbnail">No thumbnail available</div>
}
            @if (!mapDetails?.map_info?.thumbnail && loading) {
<div class="no-thumbnail">Loading...</div>
}
          </div>
      </div>

      <div class="select-player-right d-flex align-items-center justify-content-end" style="margin-top: 20px;">
        <button class="btn btn-danger" [disabled]="!planUsage?.subscription_features?.delete_maps || user_id != mapDetails?.creator.user_id" (click)="deleteMap(mapDetails)">Delete map</button>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
